import { render } from "./PrivacyPage.vue?vue&type=template&id=5df6c399&scoped=true"
const script = {}

import "./PrivacyPage.vue?vue&type=style&index=0&id=5df6c399&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df6c399"]])

export default __exports__